import { ADD_PICKUP_MONITOR_AWAITING_PICKUP_ORDER, ADD_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER, REMOVE_PICKUP_MONITOR_AWAITING_PICKUP_ORDER, REMOVE_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER, SET_PICKUP_MONITOR_AWAITING_PICKUP_ORDERS, SET_PICKUP_MONITOR_CANCEL_REASON, SET_PICKUP_MONITOR_IS_ORDERS_STATUS_UPDATING, SET_PICKUP_MONITOR_PROCESSING_PICKUP_ORDERS, SET_PICKUP_MONITOR_SELECTED_ORDER, SET_PICKUP_MONITOR_SHOW_CANCEL_ORDER, SET_PICKUP_MONITOR_SHOW_OPTIONS_MODAL, SET_PICKUP_MONITOR_SHOW_ORDER_DATA_MODAL, SET_PICKUP_MONITOR_SHOW_ORDER_MODAL, SET_PICKUP_MONITOR_SHOW_PAYMENT_MODAL, UPDATE_PICKUP_MONITOR_AWAITING_PICKUP_ORDER, UPDATE_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER } from '../../actionTypes/pickupMonitor'
import { setCancelReasonFoodoraOptions, setCancelReasonOptions } from '../all-order/constants'

const initialState = {
	awaitingPickupOrders: [],
	processingPickupOrders: [],
	selectedOrder: null,
	cancelReasonOptions: setCancelReasonOptions(),
	cancelReasonFoodoraOptions: setCancelReasonFoodoraOptions(),
	modal: {
		showPaymentMethod: false,
		showOptions: false,
		showOrder: false,
		showOrderData: false,
		showCancelOrder: false
	},
	isOrdersStatusUpdating: false,
}

export function pickupMonitorReducer (state = initialState, action) {
	switch (action.type) {
		case SET_PICKUP_MONITOR_SELECTED_ORDER:
			return {
				...state,
				selectedOrder: action.value,
			}
		case SET_PICKUP_MONITOR_SHOW_PAYMENT_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showPaymentMethod: action.showPaymentMethod,
				},
			}
		case SET_PICKUP_MONITOR_SHOW_OPTIONS_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showOptions: action.showOptions,
				},
			}
		case SET_PICKUP_MONITOR_SHOW_ORDER_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showOrder: action.value,
				},
			}
		case SET_PICKUP_MONITOR_SHOW_ORDER_DATA_MODAL:
			return {
				...state,
				modal: {
					...state.modal,
					showOrderData: action.value,
				},
			}
		case SET_PICKUP_MONITOR_AWAITING_PICKUP_ORDERS:
			return {
				...state,
				awaitingPickupOrders: action.value,
			}
		case ADD_PICKUP_MONITOR_AWAITING_PICKUP_ORDER:
			let awaitingPickupOrdersCopy1 = [...state.awaitingPickupOrders]
			const isExistAwaitingPickupOrder = awaitingPickupOrdersCopy1.find(order => order.orderId === action.value.orderId)
			if (!isExistAwaitingPickupOrder) {
				awaitingPickupOrdersCopy1.push(action.value)
			}
			return {
				...state,
				awaitingPickupOrders: awaitingPickupOrdersCopy1,
			}
		case REMOVE_PICKUP_MONITOR_AWAITING_PICKUP_ORDER:
			return {
				...state,
				awaitingPickupOrders: state.awaitingPickupOrders.filter(order => order.orderId !== action.value.orderId),
			}
		case UPDATE_PICKUP_MONITOR_AWAITING_PICKUP_ORDER:
			let awaitingPickupOrdersCopy2 = [...state.awaitingPickupOrders]
			const awaitingPickupOrdersToUpdateIndex = awaitingPickupOrdersCopy2.findIndex(order => order.orderId === action.value.orderId)
			if (awaitingPickupOrdersToUpdateIndex !== -1) {
				awaitingPickupOrdersCopy2[awaitingPickupOrdersToUpdateIndex] = action.value
			}
			return {
				...state,
				awaitingPickupOrders: awaitingPickupOrdersCopy2,
			}
		case SET_PICKUP_MONITOR_PROCESSING_PICKUP_ORDERS:
			return {
				...state,
				processingPickupOrders: action.value,
			}
		case ADD_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER:
			let processingPickupOrders1 = [...state.processingPickupOrders]
			const isExistProcessingPickupOrder = processingPickupOrders1.find(order => order.orderId === action.value.orderId)
			if (!isExistProcessingPickupOrder) {
				processingPickupOrders1.push(action.value)
			}
			return {
				...state,
				processingPickupOrders: processingPickupOrders1,
			}
		case UPDATE_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER:
			let processingPickupOrders2 = [...state.processingPickupOrders]
			const processingPickupOrdersToUpdateIndex = processingPickupOrders2.findIndex(order => order.orderId === action.value.orderId)
			if (processingPickupOrdersToUpdateIndex !== -1) {
				processingPickupOrders2[processingPickupOrdersToUpdateIndex] = action.value
			}
			return {
				...state,
				processingPickupOrders: processingPickupOrders2,
			}
		case REMOVE_PICKUP_MONITOR_PROCESSING_PICKUP_ORDER:
			return {
				...state,
				processingPickupOrders: state.processingPickupOrders.filter(order => order.orderId !== action.value.orderId),
			}
		case SET_PICKUP_MONITOR_IS_ORDERS_STATUS_UPDATING:
			return {
				...state,
				isOrdersStatusUpdating: action.value,
			}
		case SET_PICKUP_MONITOR_SHOW_CANCEL_ORDER:
			return {
				...state,
				modal: {
					...state.modal,
					showCancelOrder: action.value
				}
			}
		case SET_PICKUP_MONITOR_CANCEL_REASON:
			return {
				...state,
				cancelReason: action.value ? action.value : setCancelReasonOptions()[0].value
			}
		default:
			return state
	}
}
